export default __webpack_public_path__ + "static/media/news-09.0fb92fe0.jpg";